import 'angular';

export function PROLinkEvents ($timeout, $window, $translate, API, workshopAPI, sessionObjAPI, confirm) {
  var PROLinkEvents = function (event, vehicle) {
    this.origin = sessionObjAPI.base().origin;
    this.Event = event;
    this.vehicle = vehicle || {};
  };

  PROLinkEvents.prototype.hookUrl = function() {
    var self = this;

    return self.Event.event.vehicle_id ?
    `${self.origin}workshop.html#/${self.Event.event.customer_id}/${self.Event.event.vehicle_id}/event/${self.Event.event.id}`:
    `${self.origin}workshop.html#/${self.Event.event.customer_id}/event/${self.Event.event.id}`;
  };

  PROLinkEvents.prototype.buildQueryString = function() {
    var self = this;
    var queryString = {
      hookUrl: self.hookUrl(),
      type: 'inquiry',
      event_id: self.Event.event.id
    };

    if (self.vehicle.id) {
      let vehicle = angular.copy(self.vehicle);

      delete vehicle.follow_up_comment;

      queryString.vehicleInfo = angular.toJson(vehicle);

      queryString['NEW_ITEM-CUST_FIELD5[1]'] = self.vehicle.prolink_vehicle_id;
      queryString['NEW_ITEM-CUST_FIELD6[1]'] = self.vehicle.make;
      queryString['NEW_ITEM-CUST_FIELD7[1]'] = self.vehicle.model;
    }

    queryString['HOOKURL'] = `${API.url}/events/add_item_from_prolink/${self.Event.event.id}`;

    return $.param(queryString);
  };

  PROLinkEvents.prototype.hasSku = function(item) {
    var self = this;

    if (item) {
      return item.prolink_sku;
    }

    var items = self.Events.events.events_items_attributes.filter(function (item) {
      return item.prolink_sku;
    });

    return items.length;
  };

  PROLinkEvents.prototype.addItems = function() {
    var self = this;

    confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.BOOKING_MUST_FIRST_BE_SAVED', {name:"PROLink"}), null, 'prolinkEventsAutoSave')
    .then(function () {
      return self.Event.save();
    }).then(function () {
      $timeout(function () {
        $window.location.assign(`prolink.html?${self.buildQueryString()}`);
      });
    });
  };

  return PROLinkEvents;
}